import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, IconButton } from '@mui/material';
import PageContainer from '../../../../components/Container/pageContainer';
import { Input } from '../../../../components/input/input';
import CustomForm from '../../../../components/form/form';
import { Main } from '../../../../constant';
import { useTheme } from '@emotion/react';
import AccessibleTable from '../../../../components/table/table';
import { CustomBtn } from '../../../../components/button/button';
import { CustomSelect } from '../../../../components/select/select';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import SuggestionInput from '../../../../components/suggestionInput/suggestionInput';
import { PostRequest } from '../../../../redux/actions/PostRequest';
import { UserData } from '../../../../hooks/FirstTimeWebSrn/Websrn';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AttendanceSheet from '../../../../components/table/attendanceSheet';
import { FullDate } from '../../../../components/Date/FullDate';

const TeacherAttendanceAtt = (props) => {
    const [data, setData] = useState(Main().TeacherAttendance);
    const [select, setSelect] = useState('');
    const [userToken, setUserToken] = useState(UserData().token);
    const [tableData, setTableData] = useState();
    const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
    const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
        getfilterdata
            .map((item) => [item.name, ''])
    ));
    const api = useSelector((state) => state.Api);
    const url = useSelector((state) => state.Api.teachersuggestion);
    const manaulurl = useSelector((state) => state.Api.Teachermaunaulattendence);
    const Teachercurrentdayreport = useSelector((state) => state.Api.Teachercurrentdayreport);
    const [FilterData, setFilterData] = useState();
    const [showAllSuggestions, setShowAllSuggestions] = useState(false);
    const [selectedTeacher, setSelectedTeacher] = useState();

    const theme = useTheme();
    const style = theme.palette.Main.Attendance;

    const [inputValues, setInputValues] = useState(initialInputValues);
    const [focusData, setFocusData] = useState(0);
    const [suggestions, setSuggestions] = useState();
    const dispatch = useDispatch();

    function handleRadioChange (e) {
        setInputValues((prevValues) => ({
            ...prevValues,
            [e.target.name]: e.target.placeholder,
        }));
    }

    //     useEffect(() => {
    //                 const startDate = new Date(inputValues.startDate == '' ? new Date() : inputValues.startDate);
    //         const endDate = new Date(inputValues.endDate == '' ? new Date() : inputValues.endDate);
    // console.log(startDate, endDate)
    //         setTableData('');
    //         try {
    //             axios.get(`${Teachercurrentdayreport}`, {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Authorization': `Bearer ${userToken}`,
    //                 },
    //             })
    //                 .then((res) => {
    //                     if (res.status === 200) {
    //                         setTableData(res.data.result);
    //                     }
    //                 })
    //                 .catch((err) => {
    //                     console.error(err);
    //                 });
    //         } catch (err) {
    //             console.error(err);
    //         }
    //     }, [focusData]);


    const ChangeDate = (e) => {
        setInputValues((prevValues) => ({
            ...prevValues,
            DateFrom: `${e.$y}-${e.$M + 1}-${e.$D}`,
        }));

    }
    const ChangeDateTo = (e) => {
        setInputValues((prevValues) => ({
            ...prevValues,
            DateTo: `${e.$y}-${e.$M + 1}-${e.$D}`,
        }));

    }
    const ShowReportTeacher = (param) => {
        axios.post(api.showSpecificTeacher, param, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken}`,
            },
        })
            .then((res) => {
                if (res.status === 200)
                {
                    // console.log(res.data.result);
                    setTableData(res.data.result || []);
                    // setMaxSelectableDate(dayjs(res.data.lastrecord))
                    // console.log(tableData)
                }
            })
            .catch((err) => {
                //console.error(err); // Log the error response for debugging
            });
    }
    useEffect(() => {
        console.log("Updated tableData:", tableData);
    }, [tableData]);
    const showattendence = (event) => {
        event.preventDefault();
                    setTableData([]);
        //console.log(inputValues)
        ShowReportTeacher(inputValues)
    }
    const submitForm = async (e) => {
        e.preventDefault();
        const startDate = new Date(inputValues.startDate == '' ? new Date() : inputValues.startDate);
        const endDate = new Date(inputValues.endDate == '' ? new Date() : inputValues.endDate);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const dateRangeArray = [];
        const currentDate = new Date(startDate);
        while (currentDate <= endDate)
        {
            dateRangeArray.push({ date: formatDate(currentDate) });
            currentDate.setDate(currentDate.getDate() + 1);
        }

        inputValues.getDate = dateRangeArray;
        await dispatch(PostRequest(manaulurl, userToken, inputValues));
        setFocusData((param) => param + 1);
    }

    useEffect(() => {
        try
        {
            if (suggestions == undefined || suggestions == null)
            {
                axios.get(url, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`,
                    },
                })
                    .then((res) => {
                        if (res.status === 200)
                        {
                            setSuggestions(res.data.message);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
        } catch (err)
        {
            console.error(err);
        }
    }, [focusData]);

    function handleInputChange (e) {
        // console.log(e)
        if (e[0])
        {
            const val = e[0].substring(1, e[0].length - 1);
            const string = 'R' + val;
            // console.log(e[1])
            setSelectedTeacher(e[1])
            setInputValues((prevValues) => ({
                ...prevValues,
                [string]: e[1],
            }));
        }
        else
        {
            setInputValues((prevValues) => ({
                ...prevValues,
                [e.target.name]: e.target.value,
            }));
        }
    }
 

    return (
        <PageContainer title="Teacher Attendance">
            <Box>
                <form onSubmit={submitForm}>
                    <Grid container>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            {suggestions && (
                                <SuggestionInput
                                    simple='true'
                                    handleInputChange={handleInputChange}
                                    Suggestions={suggestions}
                                    style={style.children}
                                    name={data.text.name}
                                    showAll={showAllSuggestions}
                                />
                            )}
                            {/* <IconButton
                            onClick={toggleShowAllSuggestions}
                            sx={{
                                position: 'absolute',
                                right: '8px',
                                color: 'action.active',
                            }}
                        >
                            <ArrowDropDownIcon />
                        </IconButton> */}
                        </Grid>
                    </Grid>

                    <Grid container>
                        <CustomForm
                            data={data.inputs}
                            handleRadioChange={handleRadioChange}
                            ChangeDate={ChangeDate}
                            handleInputChange={handleInputChange}
                        />
                    </Grid>
                    <Grid container>
                        <Grid item lg={6}>
                            <div style={{ marginTop: '20px' }}></div>
                            <CustomBtn data='Submit' />
                        </Grid>
                    </Grid>
                </form>
            </Box>

            <br />
            <br />
            {suggestions && (
                <>
                    <Box><b>Teacher Detailed Attendence Report  د معلم تفصیلي حاضري راپور</b></Box>
                    <form onSubmit={showattendence}>
                        <Grid container>
                            <Grid item lg={6}>
                                <FullDate throwfullevent={ChangeDate} name='startDate' />
                            </Grid>
                            <Grid item lg={6}>
                                <FullDate throwfullevent={ChangeDateTo} name='endDate' />
                            </Grid>
                            <Grid item lg={12}>
                                <CustomBtn data="Show Attendance حاضري وښيي" />
                            </Grid>
                        </Grid>
                        <br />
                    </form>
                </>
            )}
            {tableData?.length > 0 && (
                <Box mt={2}>
                    <AttendanceSheet rows={tableData} />
                </Box>
            )}
            {/* <Box mt={5}>
                <Grid container>
                    <Grid item lg={10}>
                        {tableData && (
                            <AccessibleTable rows={tableData} />
                        )}
                    </Grid>
                </Grid>
            </Box> */}
        </PageContainer>
    );
}

TeacherAttendanceAtt.propTypes = {}

export default TeacherAttendanceAtt;